<template>
    <section>
        <b-modal v-model="open" :title="$t('message.edit_building')" ref="modal" id="modal-building-edit">
            <vue-form-generator ref="editBuilding" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.save')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import axios from 'axios' // TODO remove axios
    import mixins from '../../../modules/mixins'
    import eventBus from '../../../modules/eventBus'

    export default {
        name: 'edit-building',
        mixins: [mixins],
        data () {
            return {
                open: false,
                isValid: false,
                item: false,
                model: {
                    id: null,
                    name: null,
                    street: '',
                    houseNumber: '',
                    city: '',
                    zip: '',
                    country: '',
                    pricePerLiterHot: '',
                    pricePerLiterCold: '',
                    pricePerPower: '',
                    pricePerUnit: ''
                },
                schema: {
                    fields: [{
                        type: 'input',
                        inputType: 'hidden',
                        model: 'id'
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.name'),
                        i18n: {
                            label: 'message.name'
                        },
                        model: 'name',
                        featured: true,
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.street'),
                        i18n: {
                            label: 'message.street'
                        },
                        model: 'street',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.house_number'),
                        i18n: {
                            label: 'message.house_number'
                        },
                        model: 'houseNumber',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.city'),
                        i18n: {
                            label: 'message.city'
                        },
                        model: 'city',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.zip'),
                        i18n: {
                            label: 'message.zip'
                        },
                        model: 'zip',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.country'),
                        i18n: {
                            label: 'message.country'
                        },
                        model: 'country',
                        required: false
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_cold_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterCold',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_hot_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterHot',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_power',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.power')
                        },
                        model: 'pricePerPower',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_heat',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.heat_units')
                        },
                        model: 'pricePerUnit',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        methods: {
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.editBuilding.validate()
                if (this.isValid) {
                    axios.post(`/api/v1/edit-entity/${this.item.id}?type=${this.item.type}`, this.model)
                        .then(response => {
                            this.open = false
                            eventBus.emit('change', {force: true, source: 'edit-building'})
                        }) // TODO catch ERROR
                }
            },
            show (item) {
                this.item = item
                axios.get(`/api/v1/entity/${item.id}?type=${item.type}`).then(response => {
                    this.model = response.data.data
                })
                this.open = true
            }
        }
    }
</script>

<style scoped>

</style>
